export default __webpack_public_path__ + "static/MANUTEPUL-ISO14001-3a76286cfc18ee1fb4c036e1042bc4d3.webp";